const detectLogout = () => {
  if (typeof window === 'undefined') return
  if (typeof window.inSidedData === 'undefined') {
    return
  }
  window.localStorage.setItem('logout-event', window.inSidedData.user.userid)

  window.addEventListener('storage', (event) => {
    if (event.key === 'logout-event' && event.newValue !== event.oldValue) {
      window.location.reload()
    }
  })
}

export default detectLogout
